import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import Collapse from "@material-ui/core/Collapse";
import Container from "@material-ui/core/Container";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import ContentTOC from "./ContentTOC";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";

const ContentSlideTOC = () => {
	const classes = useStyles("Content");

	const [checked, setChecked] = React.useState(false);

	const handleChange = () => {
		setChecked((prev) => !prev);
	};

	const trigger = useScrollTrigger({
		threshold: 600,
		disableHysteresis: true,
	});
	return (
		<>
			<Box display={{ xs: "block", sm: "block", md: "block", lg: "none" }}>
				<Slide direction={"down"} in={trigger}>
					<Box
						position={"fixed"}
						left={0}
						right={0}
						top={{ xs: 64, sm: 72 }}
						width={"100%"}
						bgcolor={"rgb(242, 247, 255)"}
						zIndex={1200}
						borderBottom={"1px solid rgb(238, 238, 238)"}
						borderTop={"1px solid rgb(238, 238, 238)"}
						display={"flex"}
						alignItems="center"
					>
						<Container
							maxWidth={false}
							disableGutters
							style={{ maxWidth: 800 }}
						>
							<Box
								display={"flex"}
								alignItems={"center"}
								justifyContent={"space-between"}
								alignContent={"center"}
								flexDirection={"row"}
								flexWrap={"nowrap"}
								px={{ xs: 4, md: 0 }}
								py={2}
								position="relative"
								onClick={handleChange}
								style={{ cursor: "pointer" }}
							>
								<Box fontWeight={600} fontSize={14} letterSpacing=".07rem">
									TABLE OF CONTENTS
								</Box>

								<IconButton
									size="small"
									edge={"end"}
									aria-label="Table of contents"
								>
									<ExpandMoreIcon
										className={{
											[classes.iconExpanded]: checked,
										}}
									/>
								</IconButton>
							</Box>
							<Collapse in={checked}>
								<Box p={"10px 10px 10px 0"}>
									<div className={classes.TOCList}>
										<ContentTOC onClick={handleChange} />
									</div>
								</Box>
							</Collapse>
						</Container>
					</Box>
				</Slide>
			</Box>
		</>
	);
};

ContentSlideTOC.propTypes = {};
export default ContentSlideTOC;
